import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-green-900 text-white py-8 w-full">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div className="col-span-2 md:col-span-1">
                        <h2 className="text-xl font-semibold mb-4">About EPTech</h2>
                        <p className="text-sm mb-2">
                            EPTECH is an organization operating in the field of environmental services since 1999.
                        </p>
                        <p className="text-sm">
                            📞 +91 9816443545<br />
                            📍 #244, PH-2, HOUSING BOARD COLONY, BADDI<br />
                            ✉️ 22aj.aryan@gmail.com
                        </p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
                        <ul className="text-sm">
                            <li className="mb-2"><a href="/about" className="hover:underline">About Us</a></li>
                            <li className="mb-2"><a href="/" className="hover:underline">FAQs</a></li>
                            <li className="mb-2"><a href="/" className="hover:underline">Testimonials</a></li>
                            <li className="mb-2"><a href="/" className="hover:underline">Terms of Service</a></li>
                            <li><a href="/" className="hover:underline">Privacy Policy</a></li>
                            {/* Add additional links as needed */}
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-4">Services</h3>
                        <ul className="text-sm">
                            <li className="mb-2">Environmental Services</li>
                            <li className="mb-2">Tech Development</li>
                            {/* <li className="mb-2">Disaster Relief</li>
                            <li>Humanitarian Aid</li> */}
                            {/* Add more services if needed */}
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
                        <ul className="text-sm">
                            <li className="mb-2">Support: 22aj.aryan@gmail.com</li>
                            <li className="mb-2">Helpdesk: ajeet_jain@yahoo.com</li>
                            <li>Feedback: 22aj.aryan@gmail.com</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Copyright notice */}
            <div className="bg-green-800">
                <div className="container mx-auto px-6 py-4">
                    <p className="text-sm text-center">
                        © Copyright 2024 EPTECH. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;